import { ofType } from "redux-observable";
import { forkJoin } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import _ from "lodash";
import { fetchKeyphrases, fetchRelations } from "../helperFunctions";

// types
const SENTENCE_SCORE = "SENTENCE_SCORE";
const SENTENCE_SCORE_IN = "SENTENCE_SCORE_IN";
const SENTENCE_SCORE_MID = "SENTENCE_SCORE_MID";
const SENTENCE_SCORE_OUT = "SENTENCE_SCORE_OUT";

// actions
const sentenceScoreIn = (score) => ({
  type: SENTENCE_SCORE_IN,
  payload: score,
});
const sentenceScoreMid = (score) => ({
  type: SENTENCE_SCORE_MID,
  payload: score,
});
const sentenceScoreOut = (score) => ({
  type: SENTENCE_SCORE_OUT,
  payload: score,
});

// epics
export const inSentenceScoreEpic = (action$) =>
  action$.pipe(
    ofType(SENTENCE_SCORE),
    mergeMap((action) => {
      return fetchKeyphrases(action.payload);
    }),
    map((data) => sentenceScoreIn(data.value)),
  );

export const midSentenceScoreEpic = (action$) =>
  action$.pipe(
    ofType(SENTENCE_SCORE_IN),
    mergeMap((action) => {
      const acPayloadRelations = _.reject(action.payload, (ignore, index) => index < 1);
      return forkJoin({
        text: [action.payload[0][0]],
        relations: fetchRelations(
          action.payload[0][0],
          _.map(acPayloadRelations, (relations) => relations[0]),
        ),
      });
    }),
    map((data) => sentenceScoreMid(data)),
  );

export const outSentenceScoreEpic = (action$) =>
  action$.pipe(
    ofType(SENTENCE_SCORE_MID),
    mergeMap((action) => {
      const out = {};
      _.forEach(action.payload.relations.scores, (value, key) => {
        out[action.payload.text + " " + key] = value;
      });
      return [out];
    }),
    map((data) => sentenceScoreOut(data)),
  );

// reducer
export const keyPhraseReducer = (state = {}, action) => {
  switch (action.type) {
    case SENTENCE_SCORE_IN:
      const newState = _.cloneDeep(state);
      for (let i = 1; i < action.payload.length; i++) {
        if (newState[action.payload[0][0] + " " + action.payload[i][0]] === undefined) {
          let tags = {};
          _.forEach(action.payload[0][1], (value) => {
            tags[value] = tags[value] === undefined ? 1 : tags[value] + 1;
          });
          _.forEach(action.payload[i][1], (value) => {
            tags[value] = tags[value] === undefined ? 1 : tags[value] + 1;
          });
          newState[action.payload[0][0] + " " + action.payload[i][0]] = tags;
        }
      }
      state = newState;
      return _.cloneDeep(state);
    default:
      return _.cloneDeep(state);
  }
};

export const sentenceScoreOutReducer = (state = {}, action) => {
  switch (action.type) {
    case SENTENCE_SCORE_OUT:
      const newState = _.cloneDeep(state);
      _.forEach(action.payload, (value, key) => {
        if (newState[key] === undefined) {
          newState[key] = value;
        }
      });
      state = newState;
      return _.cloneDeep(state);
    default:
      return _.cloneDeep(state);
  }
};
